/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Update_PasswordInputs */

const en_common_update_password = /** @type {(inputs: Common_Update_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update password`)
};

const es_common_update_password = /** @type {(inputs: Common_Update_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar contraseña`)
};

/**
* | output |
* | --- |
* | "Update password" |
*
* @param {Common_Update_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_update_password = /** @type {((inputs?: Common_Update_PasswordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Update_PasswordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_update_password(inputs)
	return en_common_update_password(inputs)
});